// Sound keys are code-defined (each maps to a reading-flow trigger point). The
// actual files + volumes are administrable in Django and fetched at runtime via
// GET /api/sounds/ (see src/api/sounds.ts). This list must mirror the backend
// SOUND_KEYS in backend/apps/sounds/models.py.
export type SoundKey =
  | "wheel-entrance"     // A — CardWheel shuffle-in cascade
  | "card-whoosh"        // D — FlyingCard flight
  | "card-arrive"        // E — slot landing
  | "reading-flourish"   // G — result-ready (mystical flourish carries reveal F)
  | "ambient";           // looping site-wide background bed (never passed to play())

export interface SoundDef {
  src: string;
  volume: number; // 0..1
}

// Runtime guard so the engine ignores any unexpected key in the API response.
export const SOUND_KEYS: SoundKey[] = [
  "wheel-entrance",
  "card-whoosh",
  "card-arrive",
  "reading-flourish",
  "ambient",
];
